module.exports = __webpack_public_path__ + "static/media/expand-more.d1cc4fe7.svg";